<template>
  <dialogModel
    :title="dialogTitle"
    width="1200px"
    :visible.sync="VisibleDeRe"
    :footer="DeRe == 1"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <div class="dialog-content">
      <div class="Content">
        <div class="section-row">
          <div class="section-col">
            <div class="title">企业信息</div>
            <div class="Content-box">
              <div class="title-p">企业名称</div>
              <div class="title-con">{{ row.customerName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">统一社会信用代码</div>
              <div class="title-con">{{ row.customerCreditCode }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">法定代表人(负责人)</div>
              <div class="title-con">{{ row.customerLegalPerson }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">企业类型</div>
              <div class="title-con">{{ companyTypeText }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">纳税类型</div>
              <div class="title-con">{{ taxTypeText }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">联系电话</div>
              <div class="title-con">{{ row.customerPhone }}</div>
            </div>
          </div>

          <div class="section-col">
            <div class="title">年报信息</div>
            <div class="Content-box">
              <div class="title-p">注册资本(万元)</div>
              <div class="title-con">{{ row.registeredCapital }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">申报年份</div>
              <div class="title-con">{{ row.reportYear }}</div>
            </div>
            <template v-if="DeRe == 2">
              <div
                class="Content-box"
                v-for="(item, index) in row.shareholderVos"
                :key="'vos-' + index"
              >
                <div class="title-p">股东{{ index + 1 }}</div>
                <div class="title-con">
                  {{ item.name }} 认缴出资{{ item.subscription }}万元{{
                    item.hasPaidIn == 1 ? "已实缴" : "未实缴"
                  }}
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="Content-box"
                v-for="(item, index) in row.shareholderList"
                :key="'list-' + index"
              >
                <div class="title-p">股东{{ index + 1 }}</div>
                <div class="title-con">
                  {{ item.name }} 认缴出资{{ item.subscription }}万元{{
                    item.hasPaidIn == 1 ? "已实缴" : "未实缴"
                  }}
                </div>
              </div>
            </template>
            <div class="Content-box">
              <div class="title-p">说明</div>
              <div class="title-con">{{ row.note || "--" }}</div>
            </div>
          </div>
        </div>

        <div class="section-bottom">
          <div class="title">订单信息</div>
          <div class="info-grid">
            <div class="Content-box">
              <div class="title-p">服务金额</div>
              <div class="title-con">{{ row.amount }}元</div>
            </div>
            <div class="Content-box">
              <div class="title-p">订单时间</div>
              <div class="title-con">{{ row.orderTime || "--" }}</div>
            </div>
          </div>
          <div class="Content-box full-row">
            <div class="title-p">备注</div>
            <div class="title-con">{{ row.remark || "--" }}</div>
          </div>
        </div>

        <div
          class="section-bottom refund-block"
          v-if="DeRe == 1 || DeRe == 2"
        >
          <div class="title">退款信息</div>
          <div class="info-grid">
            <div class="Content-box" v-if="DeRe == 1">
              <div class="title-p">退款金额</div>
              <div class="title-con">{{ row.amount }}元</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">退款原因</div>
              <div class="title-con">{{ dataObj.refundReason || "--" }}</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">实际退款金额</div>
              <div class="title-con">
                {{
                  dataObj.refundAmount != null ? dataObj.refundAmount : "--"
                }}元
              </div>
            </div>
          </div>
          <div class="Instruction">(实际退款金额需后台审核)</div>
          <div class="Content-box full-row refund-reason" v-if="DeRe == 1">
            <div class="title-p">退款原因</div>
            <div class="title-con refund-input">
              <el-input
                type="textarea"
                class="textarea-lg"
                placeholder="请输入退款原因"
                v-model="textarea"
                :rows="5"
                maxlength="1500"
                show-word-limit
                resize="none"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
export default {
  props: {
    VisibleDeRe: {},
    DeRe: {},
    row: {},
    seller: {},
    dataObj: {},
  },
  data() {
    return {
      textarea: "",
    };
  },
  computed: {
    dialogTitle() {
      return this.DeRe == 0 ? "详情" : "申请退款";
    },
    companyTypeText() {
      const map = ["有限公司", "个体户", "子公司", "分公司", "其他"];
      const t = this.row && this.row.customerCompanyType;
      return map[t] != null ? map[t] : "--";
    },
    taxTypeText() {
      const t = this.row && this.row.customerTaxType;
      if (t == 0) return "小规模纳税人";
      if (t == 1) return "一般纳税人";
      return "--";
    },
  },
  methods: {
    handleClose() {
      this.$emit("handleCloseDeRe");
      this.textarea = "";
    },
    handleUnderstand() {
      this.$emit("handleConfirmDeRe", this.textarea);
      this.textarea = "";
    },
  },
};
</script>

<style scoped lang="less">
@import "../bookkeeping-detail-dialog.less";
</style>
